@if (!dialogMode()) {
@if (horizontalScroll()) {
<!-- Case 1: Horizontal scroll - fixed width, overflow-x-auto -->
<div class="flex flex-nowrap gap-2 overflow-x-auto overflow-y-visible scrollbar-hide w-full">
    @if (loading()) {
    @for (i of [1, 2, 3, 4]; track i) {
    <ng-container *ngTemplateOutlet="attachmentSkeleton; context: { horizontalScroll: true }"></ng-container>
    }
    } @else {
    @for (attachment of visibleAttachments(); track $index) {
    <ng-container
        *ngTemplateOutlet="attachmentCard; context: { $implicit: attachment, fullWidth: false, horizontalScroll: true }"></ng-container>
    }
    @if (hasMoreAttachments()) {
    <div (click)="openAllAttachmentsDialog()"
        class="flex items-center gap-2 rounded-xl transition-all duration-200 min-h-[3.375rem] cursor-pointer text-left px-3 min-w-[3.125rem] max-w-[18.75rem] w-fit flex-shrink-0 hover:bg-gray-50 border border-black/10 bg-sidebar">
        <span class="text-sm font-medium text-gray-800">See all</span>
        <i class="pi pi-chevron-right text-gray-500" style="font-size: 10px;"></i>
    </div>
    }
    }
</div>
} @else {
<!-- Case 2: Wrap to next line - grid layout -->
<div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 w-full" dir="{{gridDirection()}}">
    @if (loading()) {
    @for (i of [1, 2, 3, 4]; track i) {
    <ng-container *ngTemplateOutlet="attachmentSkeleton; context: { horizontalScroll: false }"></ng-container>
    }
    } @else {
    @for (attachment of visibleAttachments(); track $index) {
    <ng-container
        *ngTemplateOutlet="attachmentCard; context: { $implicit: attachment, fullWidth: true, horizontalScroll: false }"></ng-container>
    }
    @if (hasMoreAttachments()) {
    <div (click)="openAllAttachmentsDialog()"
        class="flex items-center gap-2 rounded-xl transition-all duration-200 min-h-[54px] cursor-pointer text-left px-3 w-full min-w-0 hover:bg-gray-50 border border-black/10 bg-sidebar">
        <span class="text-sm font-medium text-gray-800">See all</span>
        <i class="pi pi-chevron-right text-gray-500" style="font-size: 10px;"></i>
    </div>
    }
    }
</div>
}
}

<app-dialog [(visible)]="dialogVisible" [title]="'All Attachments (' + filteredAttachments().length + ')'"
    [showCloseButton]="true" (closed)="onDialogHide()" class="max-w-[60rem] h-[75vh]">
    <ng-template #bodyTemplate>
        <div class="flex flex-col h-full gap-2">
            <app-search-bar placeholder="Search with name" width="100%" [(ngModel)]="searchValue"
                (searchChange)="onSearch($event)" />
            <div class="flex flex-wrap items-center justify-between gap-2">
                <div class="flex flex-wrap gap-2">
                    @for (chip of chips(); track chip.label) {
                    <div class="px-3 py-1.5 font-medium text-sm border rounded-xl transition-all duration-150 shadow-sm cursor-pointer select-none"
                        [ngClass]="{
                        'bg-gray-50 text-gray-600 border-blue-300': activeFilter() === chip.docModel,
                        'bg-white text-gray-700 border-gray-300 hover:bg-blue-50 hover:border-gray-400': activeFilter() !== chip.docModel
                    }" (click)="onFilterChange(chip.docModel)">
                        {{ chip.label }}
                    </div>
                    }
                </div>
                @if (threadId()) {
                <app-button variant="outlined" severity="contrast" icon="download" iconSource="lucide"
                    [loading]="isDownloadingAll()" [disabled]="filteredAttachments().length === 0 || isDownloadingAll()"
                    [pTooltip]="'Download files in ' + activeFilterLabel()" tooltipPosition="top"
                    (clicked)="downloadAllInCategory()"></app-button>
                }
            </div>
            <div
                class="flex-1 min-h-0 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 auto-rows-min overflow-y-auto">
                @if (loading() || isFetching()) {
                @for (i of [1, 2, 3, 4, 5, 6]; track i) {
                <ng-container *ngTemplateOutlet="attachmentSkeleton" />
                }
                } @else {
                @for (attachment of filteredAttachments(); track $index) {
                <ng-container *ngTemplateOutlet="attachmentCard; context: { $implicit: attachment, fullWidth: true }" />
                }
                @empty {
                <div><span>No attachments found</span></div>
                }
                }
            </div>
        </div>
    </ng-template>
</app-dialog>

<ng-template #attachmentSkeleton let-horizontalScroll="horizontalScroll">
    <div [ngClass]="{
        'flex overflow-hidden rounded-xl border border-black/10 bg-sidebar text-left': true,
        'min-w-[10rem] max-w-[18rem] w-fit flex-shrink-0': horizontalScroll,
        'w-full min-w-0': !horizontalScroll
    }">
        <div
            class="shrink-0 w-11 flex items-center justify-center p-0 rounded-l-xl bg-[#E8E8E8] border-r border-black/10">
            <p-skeleton width="1.25rem" height="1.25rem" shape="rectangle"></p-skeleton>
        </div>
        <div class="flex-1 min-w-0 flex flex-col justify-center gap-1.5 overflow-hidden p-2">
            <p-skeleton width="80%" height="0.875rem"></p-skeleton>
            <p-skeleton width="60%" height="0.75rem"></p-skeleton>
        </div>
    </div>
</ng-template>

<ng-template #attachmentCard let-attachment let-fullWidth="fullWidth" let-horizontalScroll="horizontalScroll">
    <div dir="ltr" [ngClass]="{
        'group relative flex h-fit rounded-xl transition-all duration-200 overflow-hidden border border-black/10 bg-sidebar text-left': true,
        'hover:bg-gray-100 cursor-pointer': isOpenable(attachment),
        'cursor-default': !isOpenable(attachment),
        'opacity-60': isRestricted(attachment),
        'min-w-[10.625rem] max-w-[18.75rem] w-fit flex-shrink-0': horizontalScroll,
        'w-full min-w-0': !horizontalScroll
    }" [pTooltip]="isRestricted(attachment) ? 'Not available in shared view' : undefined" tooltipPosition="top"
        (click)="isOpenable(attachment) ? onOpen(attachment.attachmentData) : null">
        <div
            class="shrink-0 w-11 flex items-center justify-center pl-1.5 pr-1 py-1.5 rounded-l-xl bg-[#E8E8E8] border-r border-black/10 self-stretch">
            @if(attachment.status === 'IN_PROGRESS') {
            <i class="pi pi-spin pi-spinner text-lg text-orange-500"></i>
            } @else {
            <app-file-icon [type]="attachment.type" [imageUrl]="attachment.attachmentData?.fullUrl"
                [size]="'xxl'"></app-file-icon>
            }
        </div>
        <div class="flex-1 min-w-0 flex flex-col justify-center overflow-hidden pl-2 pr-2 py-1.5">
            <div class="text-sm font-medium text-foreground truncate max-w-full">
                {{attachment.name || attachment?.filename || 'Document'}}
            </div>
            <div class="text-xs text-muted-foreground flex items-center gap-1.5 truncate">
                @if(attachment.status === 'IN_PROGRESS') {
                <span class="text-orange-500 truncate">Uploading...</span>
                }
            </div>
        </div>
        @if(canRemove()) {
        <div (click)="onRemove(attachment)" pTooltip="Remove attachment" tooltipPosition="top"
            class="absolute top-1 right-1 h-4 w-4 rounded-full text-white flex items-center justify-center z-30 cursor-pointer hover:scale-110 transition-all duration-200 opacity-0 group-hover:opacity-100">
            <app-icon [type]="removeIcon" [source]="'svg'" [size]="'default'"></app-icon>
        </div>
        }
    </div>
</ng-template>
